module.exports = __webpack_public_path__ + "assets/img/title.a8554581.png";